import breakpoints from "assets/theme/base/breakpoints";
import { useState, useEffect } from "react";

const useGetDevice = () => {
  const checkDevice = () => window.innerWidth < breakpoints.values.sm;
  const [isMobile, setIsMobile] = useState(checkDevice());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(checkDevice());
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
};

export default useGetDevice;